import 'bootstrap/js/dist/modal'
// import IconArrow from "./icons/IconArrow";

const CalendlyButton = ({ title }) => {
  return (
    <>
      <button
        type="button"
        className="btn btn-primary btn-calendly-modal"
        data-bs-toggle="modal"
        data-bs-target="#modal-results-button-calendly"
      >{title}</button>
    </>
  );
}

export default CalendlyButton;
